import script from "./AppCartItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppCartItems.vue?vue&type=script&lang=ts&setup=true"

import "./AppCartItems.vue?vue&type=style&index=0&id=aad3f6cc&lang=scss"

const __exports__ = script;

export default __exports__